module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/comparatoregas/comparatoregas.component.scss
// module id = ./src/app/comparatoregas/comparatoregas.component.scss
// module chunks = main